export default {"src":"/_next/static/media/bookingkit-logo.2186ae39.svg","height":90,"width":192};